import { isBrowser as n } from "./index61.js";
function r() {
  return n() ? window.navigator.onLine : !0;
}
function e() {
  return !r();
}
export {
  e as isOffline,
  r as isOnline
};
//# sourceMappingURL=index13.js.map
